import { createContext, useState, useMemo } from 'react';

import { CompaniesProps } from '../api/login/types';

interface ErrorFilters {
  page: number;
  status: string;
  type: number;
  searchTerm: string;
}

interface GlobalProviderProps {
  openSnackbar: boolean;
  setOpenSnackbar: (isSnackbarOpen: boolean) => void;
  errorMessage: boolean;
  setErrorMessage: (errorMessage: boolean) => void;
  snackbarMessage: string;
  setSnackbarMessage: (message: string) => void;
  inspectionPath: string;
  setInspectionPath: (path: string) => void;
  unreadCount: number;
  setUnreadCount: (unreadCount: number) => void;
  errorFilters: ErrorFilters;
  setErrorFilters: React.Dispatch<React.SetStateAction<ErrorFilters>>;
  bankCompanyData: CompaniesProps | undefined;
  setBankCompanyData: (value: CompaniesProps | undefined) => void;
  triggerManualCompletionRefresh: () => void;
}

export const GlobalContext = createContext({} as GlobalProviderProps);

type MyComponentProps = React.PropsWithChildren;

export function GlobalProvider({ children }: MyComponentProps): JSX.Element {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [inspectionPath, setInspectionPath] = useState('');
  const [unreadCount, setUnreadCount] = useState<number>(0);
  const [bankCompanyData, setBankCompanyData] = useState<CompaniesProps>();
  const [errorFilters, setErrorFilters] = useState<ErrorFilters>({
    page: 0,
    status: '',
    type: 0,
    searchTerm: '',
  });
  const contextValue = useMemo(
    () => ({
      openSnackbar,
      setOpenSnackbar,
      errorMessage,
      setErrorMessage,
      snackbarMessage,
      setSnackbarMessage,
      inspectionPath,
      setInspectionPath,
      unreadCount,
      setUnreadCount,
      errorFilters,
      setErrorFilters,
      bankCompanyData,
      setBankCompanyData,
      triggerManualCompletionRefresh: () => undefined,
    }),
    [
      openSnackbar,
      errorMessage,
      snackbarMessage,
      inspectionPath,
      unreadCount,
      errorFilters,
      bankCompanyData,
    ]
  );

  return (
    <GlobalContext.Provider value={contextValue}>
      {children}
    </GlobalContext.Provider>
  );
}
